import { instance } from './axios.instance';

export const getOrganizationalCharts = async (proposalId) => {
  const { data } = await instance.get(
    `/proposal/${proposalId}/organizational_charts`
  );
  return data;
};

export const createBlankOrganizationalChart = async (proposalId) => {
  const { data } = await instance.post(`/proposal/${proposalId}/organizational_charts`);
  return data;
};

// Modèle « variable » : le serveur choisit l'organigramme de l'agence visée
// (concernée, parente, ou choisie explicitement dans le modèle). `chart` peut
// revenir nul — aucun défaut, plusieurs candidats — et c'est alors au commercial
// de choisir. `target.entityId` (mode agence choisie) prime sur `scope` ;
// `target.tagId` affine les trois modes d'agence (cf. orgChartResolveTarget).
export const resolveOrganizationalChart = async (proposalId, scope, target = {}) => {
  const { data } = await instance.get(
    `/proposal/${proposalId}/organizational_charts/resolve`,
    { params: { scope, entity_id: target.entityId, tag_id: target.tagId } }
  );
  return data;
};

// Agences de la société ({ id, name, parent_id }) pour le sélecteur arborescent
// du mode « agence choisie » : toutes, pas seulement la hiérarchie de la proposition.
export const getEntities = async () => {
  const { data } = await instance.get('/entities');
  return data;
};

// Étiquettes d'organigramme de la société (créées depuis l'admin web, cf.
// OrgChartManagerModal) — liste globale, pas de recherche serveur nécessaire.
// `with_coverage` ajoute à chacune le nombre d'agences qui portent réellement un
// organigramme ainsi étiqueté : le panneau de modèle s'en sert pour signaler une
// étiquette qui ne résoudra nulle part.
// Réponse : { tags: [{ id, name, entities_count }], entities_with_charts_count }
export const getOrgChartTagsWithCoverage = async () => {
  const { data } = await instance.get('/tags', { params: { with_coverage: 1 } });
  return data;
};

// Organigramme composé dans le modèle : rattaché au modèle, pas à une agence.
export const createTemplateOrganizationalChart = async (templateId) => {
  const { data } = await instance.post(
    `/proposal/templates/${templateId}/organizational_chart`
  );
  return data;
};

export const syncOrgChartFromSource = async (chartId) => {
  const { data } = await instance.post(`/organizational_charts/${chartId}/sync_from_source`);
  return data;
};
